import { Navigate, Route, Routes } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";

import { LeverIntegrationSetupPage } from "./lever/LeverIntegrationSetupPage";
import { PageUpIntegrationSetupPage } from "./pageup/PageUpIntegrationSetupPage";
import { SuccessFactorsIntegrationSetupPage } from "./successfactors/SuccessFactorsIntegrationSetupPage";
import { GreenhouseIntegrationSetupPage } from "./greenhouse/GreenhouseIntegrationSetupPage";
import { IcimsIntegrationSetupPage } from "./icims/IcimsIntegrationSetupPage";
import { WorkdayIntegrationSetupPage } from "./workday/WorkdayIntegrationSetupPage";
import { UnifiedIntegrationSetupPage } from "./unified/UnifiedIntegrationSetupPage";
import { WorkableIntegrationSetupPage } from "./workable/WorkableIntegrationSetupPage";

export function AtsIntegrationSetupRoutes() {
  const {
    clientPortalEnableSuccessFactorsAtsIntegration,
    clientPortalEnableGreenhouseAtsIntegration,
    clientPortalEnableWorkableAtsIntegration,
    clientPortalEnableIcimsAtsIntegration,
  } = useFlags();

  return (
    <Routes>
      <Route path="/lever" element={<LeverIntegrationSetupPage />} />
      <Route path="/workday" element={<WorkdayIntegrationSetupPage />} />
      <Route path="/pageup" element={<PageUpIntegrationSetupPage />} />
      <Route
        path="/successfactors"
        element={
          clientPortalEnableSuccessFactorsAtsIntegration ? (
            <SuccessFactorsIntegrationSetupPage />
          ) : (
            <Navigate to="/settings/ats-integrations" replace />
          )
        }
      />
      <Route
        path="/greenhouse"
        element={
          clientPortalEnableGreenhouseAtsIntegration ? (
            <GreenhouseIntegrationSetupPage />
          ) : (
            <Navigate to="/settings/ats-integrations" replace />
          )
        }
      />
      <Route
        path="/icims"
        element={
          clientPortalEnableIcimsAtsIntegration ? (
            <IcimsIntegrationSetupPage />
          ) : (
            <Navigate to="/settings/ats-integrations" replace />
          )
        }
      />
      <Route
        path="/workable"
        element={
          clientPortalEnableWorkableAtsIntegration ? (
            <WorkableIntegrationSetupPage />
          ) : (
            <Navigate to="/settings/ats-integrations" replace />
          )
        }
      />
      <Route path="/unified/*" element={<UnifiedIntegrationSetupPage />} />
    </Routes>
  );
}
